import { Col, Container, Row } from 'react-bootstrap';

import Button from '../../components/Button';
import { ButtonContainer, Form } from '../../components/Form';
import Loader from '../../components/Loader';
import PageHeader from '../../components/PageHeader';
import PasswordInputFormGroup from '../../components/PasswordInputFormGroup';
import Sidebar from '../../components/Sidebar';
import Transitions from '../../components/Transition';
import useChangePassword from './useChangePassword';

export default function ChangePassword() {
  const {
    handleSubmit,
    getErrorMessageByFieldName,
    currentPassword,
    handleCurrentPasswordChange,
    newPassword,
    handleNewPasswordChange,
    newPasswordConfirmation,
    handleNewPasswordConfirmationChange,
    isFormValid,
    isLoading,
  } = useChangePassword();

  return (
    <>
      <Sidebar active="ChangePassword" />
      <Loader isLoading={isLoading} />
      <Transitions>
        <PageHeader title="Alterar Senha" />
        <Form noValidate autoComplete="new-password">
          <Container>
            <Row xs={1} md={1} lg={1}>
              <Col>
                <PasswordInputFormGroup
                  label='Senha Atual'
                  value={currentPassword}
                  onChange={handleCurrentPasswordChange}
                  error={getErrorMessageByFieldName('currentPassword')}
                />
              </Col>
            </Row>
            <Row xs={1} md={1} lg={2}>
              <Col>
                <PasswordInputFormGroup
                  label='Nova Senha'
                  value={newPassword}
                  onChange={handleNewPasswordChange}
                  error={getErrorMessageByFieldName('newPassword')}
                />
              </Col>
              <Col>
                <PasswordInputFormGroup
                  label='Confirme a nova senha'
                  value={newPasswordConfirmation}
                  onChange={handleNewPasswordConfirmationChange}
                  error={getErrorMessageByFieldName('newPasswordConfirmation')}
                />
              </Col>
            </Row>
          </Container>

          <ButtonContainer>
            <Button type="button" disabled={!isFormValid} onClick={handleSubmit}>
              Alterar Senha
            </Button>
          </ButtonContainer>
        </Form>
      </Transitions>
    </>
  );
}
